export const TableHeaderColumn = [
    { headerName: 'Date', headerNameV2: 'Date', field: 'TxnDate', xlCol: { dataType: 'string', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'left', minCellWidth: "4.23%" }, showFilter: true },
    { headerName: `Txn`, headerNameV2: "Txn", field: 'TxnCount', xlCol: { dataType: 'number', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'right', minCellWidth: "6.77%" }, showFilter: true },
    { headerName: `Amount`, headerNameV2: "Amount", field: 'Amount', xlCol: { dataType: 'number', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'right', minCellWidth: "9.32%" }, showFilter: true },
    { headerName: `Txn`, headerNameV2: "Txn", field: 'RefundedCount', xlCol: { dataType: 'number', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'right', minCellWidth: "6.77%" }, showFilter: true },
    { headerName: `Amount`, headerNameV2: "Amount", field: 'RefundedAmount', xlCol: { dataType: 'number', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'right', minCellWidth: "9.32%" }, showFilter: true },
    { headerName: `%`, headerNameV2: "%", field: 'RefundedPtc', xlCol: { dataType: 'number', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'right', minCellWidth: "7.2%" }, showFilter: true },
    { headerName: `Txn`, headerNameV2: "Txn", field: 'PendingCount', xlCol: { dataType: 'number', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'right', minCellWidth: "6.77%" }, showFilter: true },
    { headerName: `Amount`, headerNameV2: "Amount", field: 'PendingAmount', xlCol: { dataType: 'number', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'right', minCellWidth: "9.32%" }, showFilter: true },
    { headerName: `%`, headerNameV2: "%", field: 'PendingPtc', xlCol: { dataType: 'number', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'right', minCellWidth: "7.2%" }, showFilter: true },
]

export const excelConfig = {
    columns: [],
    fileName: `Excel_Export.xlsx`,
    headerRowStyle: {
      font: {
        name: 'Calibri',
        family: 2,
        size: 11,
        bold: true,
        color: { argb: '00000000' },
      },
      alignment: { vertical: 'middle' },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'ffffffff' },
        bgColor: { argb: 'ffffffff' }
      }
    },
    borderStyle: {
      top: { style: 'thin', color: { argb: 'FFBDBDBD' } },
      left: { style: 'thin', color: { argb: 'FFBDBDBD' } },
      bottom: { style: 'thin', color: { argb: 'FFBDBDBD' } },
      right: { style: 'thin', color: { argb: 'FFBDBDBD' } }
    },
    pageSetup: {
      paperSize: 9,
      orientation: 'landscape',
      margins: {
        left: 0.5, right: 0.1, top: 0.4, bottom: 0.3, header: 0.1, footer: 0.1
      },
      fitToPage: true,
      fitToHeight: 0
    },
    defaultHeaderRowHeight: 20,
    defaultDataRowHeight: 20,
    showFilterSection: false,
    filterSectionData: null,
    workSheetTitle: 'Sheet 1',
    headerFooter: {
      firstHeader: null,
      firstFooter: null
    }
  }